import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=c375431c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c375431c')) {
      api.createRecord('c375431c', component.options)
    } else {
      api.reload('c375431c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=c375431c&", function () {
      api.rerender('c375431c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-49pmXpk2rXZLV/JS/pricehelp.vue"
export default component.exports